import { useState, useCallback } from 'react';

interface CodeBlockStateReturn {
  isContentExpanded: boolean;
  showSnackbar: boolean;
  handleExpandContent: () => void;
  handleCopyToClipboard: (content: string) => Promise<void>;
  setShowSnackbar: (show: boolean) => void;
}

/**
 * Manages state for code block interactions (expand/collapse and copy)
 */
export default function useCodeBlockState(): CodeBlockStateReturn {
  const [isContentExpanded, setIsContentExpanded] = useState<boolean>(false);
  const [showSnackbar, setShowSnackbar] = useState<boolean>(false);

  const handleCopyToClipboard = useCallback(async (content: string) => {
    await navigator.clipboard.writeText(content);
    setShowSnackbar(true);
  }, []);

  const handleExpandContent = useCallback(() => {
    setIsContentExpanded((prevValue) => !prevValue);
  }, []);

  return {
    isContentExpanded,
    showSnackbar,
    handleExpandContent,
    handleCopyToClipboard,
    setShowSnackbar,
  };
}
